var _path, _path2, _rect, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWatchedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4721 34.3802C21.9931 34.459 21.5013 34.5 21 34.5C16.0294 34.5 12 30.4706 12 25.5C12 20.5294 16.0294 16.5 21 16.5C25.6326 16.5 29.4477 20.0002 29.9451 24.5002C30.6217 24.5036 31.297 24.5507 31.967 24.6411C31.5288 18.9674 26.7861 14.5 21 14.5C14.9249 14.5 10 19.4249 10 25.5C10 31.5751 14.9249 36.5 21 36.5C21.7095 36.5 22.4033 36.4328 23.0754 36.3045C22.7923 35.7025 22.5869 35.0568 22.4721 34.3802Z",
    fill: "#929292"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8495 32.6086C40.4054 32.8739 40.9883 32.2868 40.6152 31.7967C38.1492 28.557 34.2521 26.4658 29.8665 26.4658C25.481 26.4658 21.5839 28.557 19.1179 31.7965C18.7448 32.2867 19.3277 32.8737 19.8836 32.6085C21.3516 31.9081 22.9835 31.358 24.7318 30.9906C24.4958 31.6037 24.3665 32.2696 24.3665 32.9658C24.3665 36.0034 26.8289 38.4658 29.8665 38.4658C32.9041 38.4658 35.3665 36.0034 35.3665 32.9658C35.3665 32.2697 35.2371 31.6037 35.0012 30.9907C36.7496 31.3581 38.3815 31.9082 39.8495 32.6086ZM33.3665 32.9658C33.3665 34.8988 31.7995 36.4658 29.8665 36.4658C27.9335 36.4658 26.3665 34.8988 26.3665 32.9658C26.3665 31.0328 27.9335 29.4658 29.8665 29.4658C31.7995 29.4658 33.3665 31.0328 33.3665 32.9658Z",
    fill: "#929292"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 10.5,
    width: 6,
    height: 3,
    fill: "#929292"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 25.5C19.5 26.3284 20.1716 27 21 27C21.8284 27 22.5 26.3284 22.5 25.5L19.5 25.5ZM19.5 18.5L19.5 25.5L22.5 25.5L22.5 18.5L19.5 18.5Z",
    fill: "#929292"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5032 18.1152C31.1191 17.5612 31.1692 16.6127 30.6152 15.9968C30.0612 15.3809 29.1127 15.3308 28.4968 15.8848L30.5032 18.1152ZM27.9968 16.3346L26.8816 17.3377L28.888 19.5681L30.0032 18.565L27.9968 16.3346ZM28.4968 15.8848L27.9968 16.3346L30.0032 18.565L30.5032 18.1152L28.4968 15.8848Z",
    fill: "#929292"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5607 15.9393C12.9749 15.3536 12.0251 15.3536 11.4393 15.9393C10.8536 16.5251 10.8536 17.4749 11.4393 18.0607L13.5607 15.9393ZM11.9393 18.5607L13 19.6213L15.1213 17.5L14.0607 16.4393L11.9393 18.5607ZM11.4393 18.0607L11.9393 18.5607L14.0607 16.4393L13.5607 15.9393L11.4393 18.0607Z",
    fill: "#929292"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchedIcon);
export default __webpack_public_path__ + "static/media/Watched_icon.a41d2b4448986470394034dc6118171e.svg";
export { ForwardRef as ReactComponent };